"use strict";
// @ts-ignore
try {
    self['workbox:window:6.2.4'] && _();
}
catch (e) { }
